<script>
    export let isActive;
</script>

<style type="text/scss">
  * {
    transition: 250ms;
  }

  .inactive {
    margin: 16px;
    cursor: pointer;

    circle:nth-child(2) {
      fill: var(--white);
      stroke: var(--sapphire);
      r: 19;
    }

    path {
      fill: var(--sapphire);
    }

    &:hover {
      circle:nth-child(2) {
        fill: var(--yellow);
        stroke: var(--sapphire);
        r: 23;
      }
    }

    &:active {
      circle:nth-child(2) {
        fill: var(--sapphire);
        stroke: var(--sapphire);
        r: 23;
      }

      path {
        fill: var(--yellow);
      }
    }
  }
</style>

{#if isActive }
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d)">
            <circle cx="40" cy="38" r="28" fill="#FFD436"/>
        </g>
        <path d="M53.3334 28.0001V48.0001C53.3334 48.8841 52.9822 49.732 52.3571 50.3571C51.732 50.9822 50.8841 51.3334 50.0001 51.3334H30.0001C29.116 51.3334 28.2682 50.9822 27.6431 50.3571C27.0179 49.732 26.6667 48.8841 26.6667 48.0001V28.0001C26.6667 27.116 27.0179 26.2682 27.6431 25.6431C28.2682 25.0179 29.116 24.6667 30.0001 24.6667H50.0001C50.8841 24.6667 51.732 25.0179 52.3571 25.6431C52.9822 26.2682 53.3334 27.116 53.3334 28.0001ZM50.0001 28.0001H30.0001V38.6334L33.6501 34.9834L42.3667 43.7001L44.0334 42.0334C44.5403 41.628 45.1784 41.4227 45.8266 41.4565C46.4748 41.4903 47.0881 41.7608 47.5501 42.2167L50.0001 44.6667V28.0001ZM41.6667 33.8334C41.6669 33.505 41.7317 33.1798 41.8574 32.8765C41.9832 32.5731 42.1675 32.2974 42.3998 32.0653C42.6321 31.8332 42.9079 31.649 43.2113 31.5235C43.5148 31.3979 43.84 31.3333 44.1684 31.3334C44.4968 31.3335 44.822 31.3983 45.1254 31.5241C45.4288 31.6499 45.7044 31.8342 45.9365 32.0665C46.1687 32.2988 46.3528 32.5745 46.4784 32.878C46.6039 33.1814 46.6685 33.5067 46.6684 33.8351C46.6682 34.4983 46.4045 35.1344 45.9353 35.6032C45.4662 36.072 44.83 36.3353 44.1667 36.3351C43.5035 36.3349 42.8675 36.0712 42.3986 35.602C41.9298 35.1329 41.6665 34.4967 41.6667 33.8334Z"
              fill="#082567"/>
        <defs>
            <filter id="filter0_d" x="0" y="0" width="80" height="80" filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                <feOffset dy="2"/>
                <feGaussianBlur stdDeviation="6"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0.95 0 0 0 0 0.773017 0 0 0 0 0.122708 0 0 0 0.4 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
            </filter>
        </defs>
    </svg>

{:else }
    <svg class="inactive" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="24" fill="white"/>
        <circle cx="24" cy="24" r="19" fill="white" stroke="#082567" stroke-width="2"/>
        <path d="M34 16.5V31.5C34 32.163 33.7366 32.7989 33.2678 33.2678C32.7989 33.7366 32.163 34 31.5 34H16.5C15.837 34 15.2011 33.7366 14.7322 33.2678C14.2634 32.7989 14 32.163 14 31.5V16.5C14 15.837 14.2634 15.2011 14.7322 14.7322C15.2011 14.2634 15.837 14 16.5 14H31.5C32.163 14 32.7989 14.2634 33.2678 14.7322C33.7366 15.2011 34 15.837 34 16.5ZM31.5 16.5H16.5V24.475L19.2375 21.7375L25.775 28.275L27.025 27.025C27.4052 26.7209 27.8837 26.567 28.3699 26.5923C28.8561 26.6176 29.316 26.8205 29.6625 27.1625L31.5 29V16.5ZM25.25 20.875C25.2501 20.6287 25.2987 20.3848 25.393 20.1573C25.4873 19.9297 25.6256 19.723 25.7998 19.5489C25.974 19.3748 26.1808 19.2367 26.4084 19.1425C26.636 19.0484 26.8799 18.9999 27.1263 19C27.3726 19.0001 27.6164 19.0487 27.844 19.143C28.0715 19.2373 28.2782 19.3756 28.4523 19.5498C28.6264 19.724 28.7645 19.9308 28.8587 20.1584C28.9529 20.386 29.0013 20.6299 29.0012 20.8763C29.0011 21.3737 28.8033 21.8507 28.4515 22.2023C28.0996 22.554 27.6224 22.7514 27.125 22.7513C26.6276 22.7511 26.1505 22.5533 25.7989 22.2015C25.4473 21.8496 25.2498 21.3724 25.25 20.875Z"
              fill="#082567"/>
    </svg>
{/if}
